import { usePage } from "@inertiajs/react";

/**
 * The quiet footer for pages families and donors land on (donation
 * pages, receipts, activation). Just help and legal links — no
 * marketing, no guides.
 */
export default function PublicFooter({ helpHref }) {
  const { routes } = usePage().props;
  const links = [
    { href: helpHref || routes?.help_donors || "/help/donors", label: "Help" },
    { href: routes?.privacy || "/privacy", label: "Privacy" },
    { href: routes?.terms || "/terms", label: "Terms" },
  ];

  return (
    <footer className="relative z-10 border-t border-border/60">
      <div className="container flex flex-col items-center gap-2 py-8 text-xs text-muted-foreground sm:flex-row sm:justify-between">
        <p>
          Read-a-thons by <a href="/" className="font-display font-semibold text-foreground hover:text-primary">PagePledge</a>
        </p>
        <nav aria-label="Footer" className="flex gap-5">
          {links.map((link) => (
            <a key={link.label} href={link.href} className="hover:text-foreground">{link.label}</a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
